__turbopack_context__.v({
  "animatedgradient": "HealthSpanSection-module__WbLTgW__animatedgradient",
  "imgD": "HealthSpanSection-module__WbLTgW__imgD",
  "imgDesktop": "HealthSpanSection-module__WbLTgW__imgDesktop",
  "imgMobile": "HealthSpanSection-module__WbLTgW__imgMobile",
  "ogdbContent": "HealthSpanSection-module__WbLTgW__ogdbContent",
  "ogdbRoot": "HealthSpanSection-module__WbLTgW__ogdbRoot",
  "root": "HealthSpanSection-module__WbLTgW__root",
  "w60": "HealthSpanSection-module__WbLTgW__w60",
  "w75": "HealthSpanSection-module__WbLTgW__w75",
});
